// GlobalFeedbackDrawer 组件专用的反馈API实现
import { jdiColorFetch } from '@/apis/colorFetchV2';
import {
  FeedbackGetListRequest,
  FeedbackGetListResponse,
  FeedbackSubmitVO,
  FeedbackSubmitResponse,
} from './feedback.interface';

//用户反馈-获取subject列表
export const fetchFeedbackGetList = async (
  requestData: FeedbackGetListRequest,
): Promise<FeedbackGetListResponse> => {
  const res = await jdiColorFetch(`user_feedback_getList`, {
    method: 'get',
    bodyQuery: requestData,
  });
  return res;
};

//用户反馈-提交反馈结果
export const fetchFeedbackSubmit = async (
  requestData: FeedbackSubmitVO,
): Promise<FeedbackSubmitResponse> => {
  const res = await jdiColorFetch(`user_feedback_add`, {
    method: 'post',
    bodyQuery: requestData,
  });
  return res;
};
